import { updatesResponseSchema, type UpdatesResponse } from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export const fetchUpdates = (options: { refresh?: boolean; signal?: AbortSignal } = {}): Promise<UpdatesResponse> =>
  apiRequest(options.refresh ? '/updates?refresh=true' : '/updates', {
    schema: updatesResponseSchema,
    signal: options.signal,
  })
